/*
 * Jira Ticket:
 * Created Date: Mon, 13th Jan 2020, 09:54:59 am
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { IconButton, InputAdornment } from '@material-ui/core';
import { Visibility, VisibilityOff } from '@material-ui/icons';

const handleMouseDownPassword = event => {
  event.preventDefault();
};

const PasswordField = ({ isFormLoading, fieldComponent, label }) => {
  const translate = useTranslate();
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Field
      name="password"
      type={showPassword ? 'text' : 'password'}
      label={label || translate('ra.auth.password')}
      component={fieldComponent || 'input'}
      disabled={isFormLoading}
      autoComplete="on"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disableRipple
              aria-label="toggle password visibility"
              style={{
                backgroundColor: 'transparent',
              }}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

PasswordField.propTypes = {
  isFormLoading: PropTypes.bool,
  label: PropTypes.string,
  fieldComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
    .isRequired,
};

PasswordField.defaultProps = {
  isFormLoading: false,
  label: null,
};

export default PasswordField;
